namespace SorAraBul.LanguageList {
    export function getValue() {
        var result: string[][] = [];
        for (var k of Administration.LanguageRow.getLookup().items) {
            if (k.LanguageId !== 'tr') {
                result.push([k.Id.toString(), k.LanguageName]);
            }
        }
        return result;
    }
}
